import React, { useEffect } from 'react';
import { Box } from '@mui/material';

const BookingReviewsWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Box sx={{ width: '100%', my: 4 }}>
      <div
        className="elfsight-app-286203f8-6e4e-4792-9c18-cfa61ac3fe47"
        data-elfsight-app-lazy
      />
    </Box>
  );
};

export default BookingReviewsWidget;
